<template>
  <v-card class="pa-3" height="330px">
    <v-card-title class="body-1">
      <span class="secondary--font font-weight-600"
        >Tickets by Priority</span
      >
      <v-tooltip top max-width="350px" color="rgba(0, 0, 0, 0.7)">
        <template v-slot:activator="{ on }">
          <v-icon
            v-on="on"
            size="20"
            class="pl-2 cursor-pointer"
            id="Tickets-by-priority"
            >mdi-information-outline</v-icon
          >
        </template>
        <span> Unresolved tickets per Priority of importance. </span>
      </v-tooltip>
    </v-card-title>
    <div class="d-flex justify-center">
      <v-avatar color="#45B6F8" size="83" class="mr-2 text-h6">
        <span class="white--text secondary--font font-weight-600">{{
          mediumPriority
        }}</span>
      </v-avatar>
      <v-avatar color="#EC48AC" size="117" class="text-h4">
        <span class="white--text secondary--font font-weight-600">{{
          highPriority
        }}</span>
      </v-avatar>
    </div>
    <div class="custom-div">
      <v-avatar color="#545C6C" size="67" class="body-1">
        <span class="white--text secondary--font font-weight-600">{{
          lowPriority
        }}</span>
      </v-avatar>
    </div>
    <div class="d-flex justify-space-between px-9 py-3">
      <span class="body-1">
        <v-icon color="#EC48AC">mdi-circle </v-icon>
        High
      </span>
      <span class="body-1">
        <v-icon color="#45B6F8">mdi-circle</v-icon>
        Medium
      </span>
      <span class="body-1">
        <v-icon color="#545C6C">mdi-circle</v-icon>
        Low
      </span>
    </div>
  </v-card>
</template>
<script>
import { $dashboard } from "@/services/Index";
export default {
  name: "ticket-priority",
  data() {
    return {
      highPriority: 0,
      mediumPriority: 0,
      lowPriority: 0,
      loading: false,
    };
  },
  mounted() {
    this.getPriorityTickets();
  },
  methods: {
    /** get Tickets By Priority data from API's */
    async getPriorityTickets() {
      this.loading = false;

      await $dashboard
        .ticketPriority({})
        .then((response) => {
          this.highPriority = response.data.high ? response.data.high : 0;
          this.mediumPriority = response.data.medium ? response.data.medium : 0;
          this.lowPriority = response.data.low ? response.data.low : 0;
          this.loading = true;
        })
        .catch(() => {
          this.loading = true;
        });
    },
  },
};
</script>
<style>
.custom-div {
  position: inherit;
  text-align: center;
  right: 27px;
  top: -20px;
}
</style>
